import { useT } from '../context/LanguageContext';
import React from 'react';
import { ArrowRight, MapPin } from 'lucide-react';
import { mockData } from '../mock';
import { useContent } from '../context/ContentContext';
import { SiteFieldEditor } from './admin/SiteFieldEditor';

const Venues = () => {
  const { t } = useT();
  const { content } = useContent();
  const venues = Array.isArray(content.site?.venues) ? content.site.venues : mockData.venues;
  return (
    <section id="steder" className="bg-black py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="flex flex-wrap items-center justify-between gap-4 mb-8 md:mb-12">
          <h2 className="text-4xl md:text-7xl font-bold text-white tracking-tighter" style={{ fontFamily: "'Oktah Round', sans-serif" }}>
            {t('Overnatting & Arena')}
          </h2>
          <SiteFieldEditor title="Rediger stader og bilete" fieldKeys={['venues']} testId="edit-site-venues-button" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-sm md:max-w-none mx-auto">
          {venues.map((v) => (
            <div key={v.name} className="group relative rounded-3xl overflow-hidden bg-[#1a1424] border border-white/5">
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  data-edit-fields="venues"
                  src={v.image}
                  alt={`${v.name} – Refuel Weekend, Rong i Øygarden`}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/50 to-transparent" />
              </div>
              <div className="p-6 md:p-8">
                <div className="flex items-center gap-1.5 text-[#ff2e2e] mb-2 md:mb-3">
                  <MapPin size={18} />
                  <span className="font-semibold uppercase tracking-widest text-xs">Rong, Øygarden</span>
                </div>
                <h3
                  data-edit-fields="venues"
                  className="cursor-pointer text-2xl md:text-3xl font-bold text-white tracking-tight mb-3 md:mb-4 leading-tight"
                  style={{ fontFamily: "'Oktah Round', sans-serif" }}
                >
                  {t(v.name)}
                </h3>
                <p data-edit-fields="venues" className="cursor-pointer text-white/70 leading-relaxed mb-5 md:mb-6 text-sm md:text-base">{t(v.description)}</p>
                <a
                  href={v.link}
                  target="_blank"
                  rel="noreferrer noopener"
                  data-testid={`venue-link-${v.link.includes('kommune') ? 'skule' : 'arena'}`}
                  className="inline-flex items-center gap-2 text-[#ff2e2e] font-semibold hover:gap-3 transition-all text-sm md:text-base"
                >
                  {t('Les meir')} <ArrowRight size={18} />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Venues;
